import { queryOptions } from '@tanstack/react-query'
import logApi from 'api/logApi'
import _ from 'lodash'

export const queryKeys = {
  base: {
    scope: ['general', 'findLogModal'],
    entity: 'log',
  },
  lists: (params) =>
    queryOptions({
      queryKey: [queryKeys.base, params],
      queryFn: () => logApi.listAll(params),
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: true,
      retry: false,
      select: (res) => ({
        total: _.get(res, 'data.totalItems', 0),
        rows: _.get(res, 'data.items', []),
        companys: _.get(res, 'data.companys', []),
      }),
    }),
}
